export const RESET_IMPORT_WIZARD = 'RESET_IMPORT_WIZARD';
export type RESET_IMPORT_WIZARD = typeof RESET_IMPORT_WIZARD;

export interface ResetImportWizard {
    type: RESET_IMPORT_WIZARD;
}

export function resetImportWizardAction(): ResetImportWizard {
    return {
        type: RESET_IMPORT_WIZARD
    };
}
